"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomError = void 0;
class CustomError extends Error {
    constructor() {
        super(...arguments);
        this.customError = true;
    }
}
exports.CustomError = CustomError;
//# sourceMappingURL=errors.js.map